
<template>
  <div class="select-other-wrapper">
    <div class="top">
      <van-search
        v-model="topicText"
        @input="handleSearch()"
        shape="round"
        autofocus
        class="search-input"
        placeholder="请输入关键词搜索" />
      <span @click="handleCancel" class="cancel-btn">取消</span>
    </div>
    <div v-if="list.length && !loading" class="erp-list">
      <div v-for="item in list" :key="item.userName">
        <div class="list-item" @click="handleSelectTopic(item)">
          <div class="item-info">
              <h4># {{item.content}} #<span class="authority" v-if="item.authority">推荐</span></h4>
              <div v-if="item.id">
                <span>{{item.partNum}}人参与</span>
                <span>{{item.postNum}}条畅聊</span>
              </div>
              <div v-else>新话题</div>
          </div>
        </div>
        <van-divider />
      </div>
    </div>
    <van-loading v-else-if="!list.length && loading" size="24px" vertical>加载中...</van-loading>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '../../api/index';
import { throttle } from '../../utils/lib'

export default {
  data() {
    return {
      topicText: '',
      loading: false,
      list: [],
    }
  },
  computed: {
    ...mapState(['authorityTopicList', 'hotTopicList']),
  },
  watch: {
    topicText: {
      immediate: true,
      handler(_topicText) {
        if (!_topicText) {
          this.list = [...(this.hotTopicList?.slice(0, 5) || [])  , ...(this.authorityTopicList?.slice(0, 5) || [])];
        }
      }
    }
  },
  methods: {
    fetchTopicList() {
      this.list = []
      if (this.topicText) {
        this.loading = true  
        api.searchTopic(this.topicText).then(res => {
          this.loading = false
          const { code, data } = res
          if (code === 200) {
            if (data?.length) {
              this.list = data
            } else {
              this.list = [
                {
                  id: 0,
                  content: this.topicText
                }
              ]
            }
          }
        })
      }
    },
    handleSelectTopic(item) {
      this.$emit('select', item)
    },
    handleSearch: throttle(function() {
      this.fetchTopicList()
    }, 1000),
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less" scoped>
.select-other-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 9999;
  font-size: 14px;
  height: 100vh;
  overflow: hidden;
  .erp-list {
    overflow-y: auto;
    height: 100%;
    padding-bottom: 70px;
    box-sizing: border-box;
  }
  .top {
    display: flex;
    align-items: center;
    // padding: 0 16px;
    margin-right: 14px;
    .search-input {
      flex: 1;
    }
  }
  .list-item {
    display: flex;
    padding: 5px 20px;
    text-align: left;
  }
  .item-info {
    margin-left: 10px;
    & > h4 {
      font-size: 15px;
      font-weight: bold;
      margin: 0;
      display: flex;
      align-items: center;
      .authority {
        font-size: 12px;
        background: #ef452e;
        color: #fff;
        flex-shrink: 0;
        padding: 0 4px;
        border-radius: 4px;
        margin-left:8px;
        transform: scale(0.8);
      }
    }
    & > div {
        font-size: 12px;
        color: #bfbfbf;
        margin-top: 4px;
        & > span {
          margin-right: 12px;
        }
      }
  }
  .item-avatar {
    flex-shrink: 0;
  }
  .ellip {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 290px;
  }
  .label {
    color: #606266;
  }
  .item-org {
    font-size: 12px;
  }
  /deep/ .van-divider {
    margin: 10px;
  }
  .cancel-btn {
    color: #2695F1;
  }
}
</style>
